// import lozad from 'lozad';
import Glide from '@glidejs/glide';
import Zooming from 'zooming';
import idleTimer from './idle-timer';
import Modal from './modal';
import polyfillArrayFrom from './lib/polyfill-array-from';
import polyfillObjectAssign from './lib/polyfill-object-assign';
import { _toggleState } from './lib/utils';
import injectGoogleMapsApiScript from './google-maps-load';

// IE11 doesn't support:
// Array.from()
polyfillArrayFrom();
// Object.assign()
polyfillObjectAssign();

const domLoad = () => {
  const $root = document.documentElement;

  // google map
  const $googleMapEl = document.getElementById('map');

  function initGoogleMap() {

    //create empty LatLngBounds object
    const bounds = new google.maps.LatLngBounds();
    const zoomLevel = 15;

    const infowindow = new google.maps.InfoWindow();


    const locations = [
      ['Areál Poldi: Brownfield', 50.158351, 14.119493, 2],
      ['Areál Poldi: Kanceláře', 50.157979, 14.126220, 1],
    ];

    const $googleMap = new google.maps.Map($googleMapEl, {
      styles: [{
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
          color: '#e9e9e9',
        }, {
          lightness: 17,
        }],
      }, {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{
          color: '#f5f5f5',
        }, {
          lightness: 20,
        }],
      }, {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#ffffff',
        }, {
          lightness: 17,
        }],
      }, {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#ffffff',
        }, {
          lightness: 29,
        }, {
          weight: 0.2,
        }],
      }, {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{
          color: '#ffffff',
        }, {
          lightness: 18,
        }],
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
          color: '#f5f5f5',
        }, {
          lightness: 21,
        }],
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{
          color: '#dedede',
        }, {
          lightness: 21,
        }],
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{
          visibility: 'on',
        }, {
          color: '#ffffff',
        }, {
          lightness: 16,
        }],
      }, {
        elementType: 'labels.text.fill',
        stylers: [{
          saturation: 36,
        }, {
          color: '#333333',
        }, {
          lightness: 40,
        }],
      }, {
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off',
        }],
      }, {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{
          color: '#f2f2f2',
        }, {
          lightness: 19,
        }],
      }, {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#fefefe',
        }, {
          lightness: 20,
        }],
      }, {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#fefefe',
        }, {
          lightness: 17,
        }, {
          weight: 1.2,
        }],
      }],
      zoom: zoomLevel,
      center: locations[0].lat,
    });

    locations.forEach((location) => {

      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(location[1], location[2]),
        map: $googleMap,
        title: 'Areál Poldi',
      });

      //extend the bounds to include each marker's position
      bounds.extend(marker.position);

      google.maps.event.addListener(marker, 'click', (function(marker, location) {
        return function() {
          infowindow.setContent(location[0]);
          infowindow.open($googleMap, marker);
        }
      })(marker, location));

    });

    $googleMap.fitBounds(bounds);


    //(optional) restore the zoom level after the map is done scaling
    const googleMapListener = google.maps.event.addListener($googleMap, 'idle', function () {
      $googleMap.setZoom(zoomLevel);
      google.maps.event.removeListener(googleMapListener);
    });


  }

  if ($googleMapEl) {

    window.initGoogleMap = initGoogleMap;

    injectGoogleMapsApiScript({
      key: 'AIzaSyDXi_RYnw-mzBKtZjmpLbRxeE02xtLUK0Y',
      callback: 'initGoogleMap',
    });

  }


  // forms + label
  // const $textareas = document.querySelectorAll('textarea');
  // const $inputs = document.querySelectorAll('input');
  const $inputs = document.querySelectorAll('input, textarea');
  // const $textareas = document.querySelectorAll('.input-item');
  if ($inputs.length > 0) {
    Array.from($inputs).forEach(($input) => {
      // IE11 Does not support the second parameter for the toggle method
      if ($input.value || $input.value.length > 0) {
        $input.classList.add('has-value');
      } else {
        $input.classList.remove('has-value');
      }

      $input.addEventListener('blur', () => {
        if ($input.value || $input.value.length > 0) {
          $input.classList.add('has-value');
        } else {
          $input.classList.remove('has-value');
        }
      });

      $input.addEventListener('keyup', () => {
        if ($input.value || $input.value.length > 0) {
          $input.classList.remove('no-value');
        } else {
          $input.classList.add('no-value');
        }
      });
    });
  }

  const $header = document.querySelector('#header');
  if ($header) {
    // Mobile menu
    const $menu = $header.querySelector('#navigation');
    const $mobileMenuToggle = document.querySelector('#mobile-menu-toggle');
    $mobileMenuToggle.addEventListener(
      'click',
      (event) => {
        _toggleState($menu, 'closed', 'open');
        _toggleState($mobileMenuToggle, 'closed', 'open');
        $root.classList.toggle('navigation-open');

        event.preventDefault();
      },
      false,
    );
  }

  // // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // // features are natively supported.
  // if (!('IntersectionObserver' in window
  //     && 'IntersectionObserverEntry' in window
  //     && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
  //   console.log('YES ie11');
  // } else {
  //   console.log('NOT ie11');

  //   // Minimal polyfill for Edge 15's lack of `isIntersecting`
  //   // See: https://github.com/w3c/IntersectionObserver/issues/211
  //   if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
  //     Object.defineProperty(window.IntersectionObserverEntry.prototype,
  //       'isIntersecting', {
  //       get: function () {
  //         return this.intersectionRatio > 0;
  //       }
  //     });
  //   }

  //   const $lozads = document.querySelectorAll('[data-lozad]');
  //   if ($lozads.length > 0) {
  //     const lazyLoad = lozad($lozads, {
  //       rootMargin: '50% 50%', // syntax similar to that of CSS Margin
  //       // threshold: 0, // ratio of element convergence
  //       // loaded: function($el) {
  //       //   if ($pageShowcase || $pageWorkbench) {
  //       //     // https://codepen.io/aminta/pen/VdeyVr?editors=1010
  //       //     imagesLoaded($masonary, function() {
  //       //       // console.log('images are loaded!');
  //       //       msnry.layout();
  //       //     });
  //       //     msnry.layout(); // make a relayout each time a new image is lazy loaded by scrolling down
  //       //   }
  //       // }
  //       loaded($element) {
  //         $element.classList.add('loaded');
  //         const $parent = $element.parentElement;

  //         // if carousel, load all images at once
  //         if ($parent.getAttribute('data-carousel-item')) {
  //           const $carouselItems = $parent.parentElement.querySelectorAll(
  //             '[data-src]',
  //           );
  //           $carouselItems.forEach($carouselItem => lazyLoad.triggerLoad($carouselItem));
  //         }

  //       },
  //     });
  //     // lazy loads elements with default selector as '.lozad'
  //     lazyLoad.observe();
  //   }
  // }

  const $carousels = document.querySelectorAll('[data-carousel]');
  if ($carousels.length > 0) {

    Array.from($carousels).forEach(($carousel) => {
      const settings = JSON.parse($carousel.getAttribute('data-carousel'));
      const defaults = {
        type: 'slider',
        // touchAngle: 10,
        swipeThreshold: 50,
        classes: {
          direction: {
            ltr: 'carousel--ltr',
            rtl: 'carousel--rtl',
          },
          slider: 'carousel--slider',
          carousel: 'carousel--carousel',
          swipeable: 'carousel--swipeable',
          dragging: 'carousel--dragging',
          cloneSlide: 'carousel__slide--clone',
          activeNav: 'carousel__bullet--active',
          activeSlide: 'carousel__slide--active',
          disabledArrow: 'carousel__arrow--disabled',
        },
      };

      const glide = new Glide($carousel, Object.assign(defaults, settings));

      glide.on('move', () => {
        $carousel.classList.add('carousel-transition');
      });
      glide.on('move.after', () => {
        $carousel.classList.remove('carousel-transition');
      });

      glide.mount();
    });

    idleTimer({
      // function to fire after idle
      callback: () => document.body.classList.add('is-idle'),
      // function to fire when active
      activeCallback: () => document.body.classList.remove('is-idle'),
      // Amount of time in milliseconds before becoming idle. default 60000
      idleTime: 2000,
    });

  }

  // Lightbox (zooming)
  const zooming = new Zooming({
    // bgOpacity: 0,
    // customSize: '100%',
    enableGrab: false,
    // preloadImage: true,
    scaleBase: 0.8,
    scrollThreshold: 20,
    // transitionDuration: 0.0001,
    zIndex: 1000,
  });
  zooming.listen('[data-zooming]');

  // Modal
  const $modals = document.querySelectorAll('[data-toggle="modal"]');
  if ($modals.length > 0) {
    Array.from($modals).forEach(($modal) => {
      const modal = new Modal($modal);
    });
  }
};

export default domLoad;
